export default __webpack_public_path__ + "static/media/letter-white.60ea3fd6.svg";